import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
export default function ReviewIconButton({ label, icon: Icon, ...props }) {
  return (
    <Tooltip title={label}>
      <span>
        <IconButton size="small" aria-label={label} {...props}>
          <Icon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
